// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__bQ_e_","right":"styles_right__1GQjL"};